import useCurrentSession from '@/hooks/use-current-session'

export const useUserIdState = () => {
  const session = useCurrentSession()

  const idState = session?.identity_verified_state
  const isUserIdUnverified = idState === null || idState === 'unverified' || idState === 'declined'
  const isUserIdPending = idState === 'pending'
  const isUserIdVerified = idState === 'verified'

  return { isUserIdPending, isUserIdUnverified, isUserIdVerified }
}
